import { useMemo } from 'react'
import { featureFlagLabels, featureFlagCollectionMap, allChildFlags } from '../types/tenant.types'

interface TreeNode {
  title: string
  value: string
  key: string
  children?: TreeNode[]
}

export function useFeatureFlagSelect() {
  // Build tree data: parent flags have children nested, standalone flags are root nodes
  const treeData = useMemo(() => {
    const nodes: TreeNode[] = []

    for (const [value, label] of Object.entries(featureFlagLabels)) {
      // Skip child flags — they'll be nested under their parent
      if (allChildFlags.has(value)) continue

      const children = featureFlagCollectionMap[value]
      if (children) {
        nodes.push({
          title: label,
          value,
          key: value,
          children: children.map(child => ({
            title: featureFlagLabels[child] || child,
            value: child,
            key: child
          }))
        })
      } else {
        nodes.push({ title: label, value, key: value })
      }
    }

    return nodes
  }, [])

  return { treeData }
}
